export const CFGet = ({
    url,
    params,
    customHeaders,
    originURL,
    loaderName
}) => {
    if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
    let paramString = '';
    let headers = {
        'Access-Control-Allow-Origin': originURL,
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    };

    if (params && Object.keys(params).length > 0)
        paramString = Object.keys(params).map(paramKey => {
            return `${paramKey}=${params[paramKey]}`;
        }).join('&');

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        })
    }

    return fetch(
        url + (paramString !== '' ? `?${paramString}` : ''), {
            credentials: 'include',
            headers: headers
        }
    ).then(response => {
        if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);
        return response.ok ? response.json() : response;
    });
}

export const CFPost = ({
    url,
    body,
    customHeaders,
    originURL,
    loaderName
}) => {
    if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
    let headers = {
        'Access-Control-Allow-Origin': originURL,
        'Content-Type': 'application/json'
    };

    if (customHeaders && Object.keys(customHeaders).length > 0) {
        Object.keys(customHeaders).forEach(headerTitle => {
            headers[headerTitle] = customHeaders[headerTitle];
        })
    }
    return fetch(
        url, {
            credentials: 'include',
            headers: headers,
            method: 'POST',
            body: JSON.stringify(body)
        }
    ).then(response => {
        if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);

        if (response.ok) {
            let returnResponse;

            try {
                returnResponse = response.text().then(t => {
                    return t ? JSON.parse(t) : {}
                });
            } catch (error) {
                return response;
            }

            return returnResponse;
        }
        return response;
    });
}

export const CFNavTo = ({
    url,
    params
}) => {
    if (params !== undefined && params !== null) {
        console.error('CFNavTo with Params NOT IMPLEMENTED');
    } else {
        console.log(url);
        window.location = url;
    }
}


// WEBPACK FOOTER //
// ./src/util/api.js